import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { pexios, toast, validate } from '../../utils/functions';
import { history } from '../../utils/variables';
import Input from '../../components/master/Input';
import CarSelect from '../../components/master/CarSelect';
import Plate from '../../components/expert/Plate';
import SearchablePicker from '../../components/master/SearchablePicker';
import UserDocs from '../../components/pages/profileEdit/UserDocs';
import { toast as toast2 } from 'react-toastify';
export default function UserCarInfo() {


    /////
    const [step,setStep] = useState(0);
    const [searchInfo,setSearchInfo] = useState({
        nationalId : '',
        plate_type: 'car',
        plate_iran: '',
        plate_left: '',
        plate_center: '',
        plate_right: '',
    })
    const [searchLoader,setSearchLoader] = useState(false)

    const form =useRef(null);

    const { user } = useSelector((store) => store);

    const [data, setData] = useState({
        chassis_number: null,
        car_type_id: null,
        car_brand_id: null,
        car_model_id: null,
        third_insurance_number: null,
        third_insurance_company: null,
        body_insurance_number: null,
        body_insurance_company: null,
        plate_type: 'car',
        plate_iran: null,
        plate_left: null,
        plate_center: null,
        plate_right: null,
    });
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [hasBodyInsurance, setHasBodyInsurance] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        pexios('api/v2/get_insurance')
            .then(res => {
                setInsuranceCompanies(res.data.data);
            });
    }, []);

    function changeData(value, name) {
        setData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }
    ///
    function changeDataSearchInfo(value, name) {
        setSearchInfo(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }
    function submit() {
        const error = validate(form);
        if (error) {
            toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            return;
        }
        setLoader(true);
        pexios(`api/save_user_car_info`, 'post', data)
            .then(() => {
                history.push('/');
            });
    }
    ///
    function searchData() {
        toast2.dismiss();
        //checking data
        if(searchInfo.nationalId.length !== 10) {
            toast('شماره حساب بانک ملت را به درستی وارد کنید', 'error');
        }else if(!!searchInfo.plate_iran.trim() === false || !!searchInfo.plate_center.trim() === false || !!searchInfo.plate_left.trim() === false || !!searchInfo.plate_right.trim() === false ){
            toast('شماره پلاک را کامل وارد کنید.', 'error');
        }else {
            setSearchLoader(true);
            setStep(0)
        }
    
    }

    return (
        <div className='content details'>
            <div className='row text-right' ref={form}>
                {/* <Input
                    label='شماره شاسی'
                    value={data.chassis_number}
                    required
                    onChange={value => changeData(value, 'chassis_number')}
                />
                <CarSelect
                    data={{
                        carType: data.car_type_id,
                        carBrand: data.car_brand_id,
                        carModel: data.car_model_id,
                    }}
                    required
                    onChange={(value, type) => changeData(value, type)}
                /> */}
                {/* <Input
                    label='شماره بیمه نامه ثالث'
                    value={data.third_insurance_number}
                    required
                    onChange={value => changeData(value, 'third_insurance_number')}
                /> */}
                <SearchablePicker
                    label='شرکت بیمه نامه ثالث'
                    value={data.third_insurance_company}
                    data={insuranceCompanies}
                    titleKey='title'
                    valueKey='id'
                    rtl
                    required
                    onSelect={val => changeData(val, 'third_insurance_company')}
                />
                {/* <div className='col-12'>
                    <label className='custom-checkbox mt20'>
                        <input type='checkbox' checked={hasBodyInsurance} onChange={(e) => setHasBodyInsurance(e.target.checked)} />
                        <span className='checkmark' />
                    </label>
                    <span className='mr35'>بیمه بدنه دارم</span>
                </div> */}
                {
                    // hasBodyInsurance &&
                    //     <>
                    //         <Input
                    //             label='شماره بیمه نامه بدنه'
                    //             value={data.body_insurance_number}
                    //             required
                    //             onChange={value => changeData(value, 'body_insurance_number')}
                    //         />
                            <SearchablePicker
                                label='شرکت بیمه نامه بدنه'
                                value={data.body_insurance_company}
                                data={insuranceCompanies}
                                rtl
                                placeholder='شرکت بیمه نامه بدنه'
                                titleKey='title'
                                valueKey='id'
                                //required
                                onSelect={val => changeData(val, 'body_insurance_company')}
                            />
                        // </>
                }
                {/* <Plate
                    type={data.plate_type}
                    plate={{
                        plate_iran: data.plate_iran,
                        plate_left: data.plate_left,
                        plate_center: data.plate_center,
                        plate_right: data.plate_right,
                    }}
                    change={(value, name) => changeData(value, name)}
                /> */}
            </div>
            {/* <UserDocs
                data={user}
            /> */}
            <div className='mt20 pr5 pl5'>
                <button
                    className='btn btn-green btn-block btn-circle'
                    disabled={loader}
                    onClick={submit}
                >
                    {
                        loader ?
                            <i className='fas fa-spinner fa-spin'/> :
                            'ثبت اطلاعات'
                    }
                </button>
            </div>
        </div>
        // <div className='content userCarInfo'>
        // <div className='d-flex swip-header fullWidth'>
        //     <span className={`glider ${step === 0 ? 'first': 'second'}`}/>
        //     <span className={`swip-option ${step === 0 ? 'active': ''}`} onClick={()=>setStep(0)}>تکمیل اطلاعات</span>
        //     <span className={`swip-option ${step === 1 ? 'active': ''}`} onClick={()=>setStep(1)}>استعلام اطلاعات</span>
        // </div>
        // <div className='swip-body'>
        //     {
        //         step === 1 ?
        //         <div className='content'>
        //             <div className='row text-right'>
        //             <Input 
        //                 label='کد ملی'
        //                 required
        //                 value={searchInfo.nationalId}
        //                 onChange={value => changeDataSearchInfo(value, 'nationalId')}
        //                 col={12}
        //             />
        //             </div>
        //             <div className='row text-right'>
        //             <Plate
        //                 type={searchInfo.plate_type}
        //                 plate={{
        //                     plate_iran: searchInfo.plate_iran,
        //                     plate_left: searchInfo.plate_left,
        //                     plate_center: searchInfo.plate_center,
        //                     plate_right: searchInfo.plate_right,
        //                 }}
        //                 required
        //                 // fixed={true}
        //                 change={(value, name) => changeDataSearchInfo(value, name)}
        //             />
        //             </div>
        //             <div className='mt25 pr5 pl5'>
        //                 <button
        //                     className='btn btn-green btn-block btn-circle'
        //                     disabled={searchLoader}
        //                     onClick={searchData}
        //                 >
        //                     {
        //                         searchLoader ?
        //                             <i className='fas fa-spinner fa-spin'/> :
        //                             'مرحله بعد'
        //                     }
        //                 </button>
        //             </div>
        //         </div>
        //         :
        //         <div className='content details'>
        //             <div className='row text-right' ref={form}>
        //                 <Input
        //                     label='شماره شاسی'
        //                     value={data.chassis_number}
        //                     required
        //                     onChange={value => changeData(value, 'chassis_number')}
        //                 />
        //                 <CarSelect
        //                     data={{
        //                         carType: data.car_type_id,
        //                         carBrand: data.car_brand_id,
        //                         carModel: data.car_model_id,
        //                     }}
        //                     required
        //                     onChange={(value, type) => changeData(value, type)}
        //                 />
        //                 <Input
        //                     label='شماره بیمه نامه ثالث'
        //                     value={data.third_insurance_number}
        //                     required
        //                     onChange={value => changeData(value, 'third_insurance_number')}
        //                 />
        //                 <SearchablePicker
        //                     label='شرکت بیمه نامه ثالث'
        //                     value={data.third_insurance_company}
        //                     data={insuranceCompanies}
        //                     titleKey='title'
        //                     valueKey='id'
        //                     rtl
        //                     required
        //                     onSelect={val => changeData(val, 'third_insurance_company')}
        //                 />
        //                 <div className='col-12'>
        //                     <label className='custom-checkbox mt20'>
        //                     {/* بیمه بدنه دارم */}
        //                         <input type='checkbox' checked={hasBodyInsurance} onChange={(e) => setHasBodyInsurance(e.target.checked)} />
        //                         <span className='checkmark' />
        //                     </label>
        //                     <span className='mr35'>بیمه بدنه دارم</span>
        //                 </div>
        //                 {
        //                     hasBodyInsurance &&
        //                         <>
        //                             <Input
        //                                 label='شماره بیمه نامه بدنه'
        //                                 value={data.body_insurance_number}
        //                                 required
        //                                 onChange={value => changeData(value, 'body_insurance_number')}
        //                             />
        //                             <SearchablePicker
        //                                 label='شرکت بیمه نامه بدنه'
        //                                 value={data.body_insurance_company}
        //                                 data={insuranceCompanies}
        //                                 rtl
        //                                 placeholder='شرکت بیمه نامه بدنه'
        //                                 titleKey='title'
        //                                 valueKey='id'
        //                                 required
        //                                 onSelect={val => changeData(val, 'body_insurance_company')}
        //                             />
        //                         </>
        //                 }
        //                 <Plate
        //                     type={data.plate_type}
        //                     plate={{
        //                         plate_iran: data.plate_iran,
        //                         plate_left: data.plate_left,
        //                         plate_center: data.plate_center,
        //                         plate_right: data.plate_right,
        //                     }}
        //                     change={(value, name) => changeData(value, name)}
        //                 />
        //             </div>
        //             <UserDocs
        //                 data={user}
        //             />
        //             <div className='mt20 pr5 pl5'>
        //                 <button
        //                     className='btn btn-green btn-block btn-circle'
        //                     disabled={loader}
        //                     onClick={submit}
        //                 >
        //                     {
        //                         loader ?
        //                             <i className='fas fa-spinner fa-spin'/> :
        //                             'تایید'
        //                     }
        //                 </button>
        //             </div>
        //         </div>
        //     }
        // </div>
        // </div>
    );
};
